// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"619":"cb5432ae","668":"0cc29239"}[chunkId] + ".chunk.css";
};